import { __rest } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { Root } from './styled.js';

const ButtonGroup = React.forwardRef((_a, ref) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-button-group' }, props, { ref: ref, role: 'group', className: cn(['tend-ui-button-group-root', className]) }), children));
});
ButtonGroup.displayName = 'ButtonGroup';

export { ButtonGroup };
